<template>
  <div id="app" :class="$mq === 'sm' ? 'is-mobile' : 'is-desktop'">
    <router-view/>
  </div>
</template>

<script>
export default {
  data () {
    return {
      size: null
    }
  },
  mounted () {
    this.setSize()
    window.addEventListener('resize', this.setSize)
  },
  methods: {
    setSize () {
      this.size = screen.width / 36
      if (this.size >= 14) {
        this.size = 14
      }
      document.documentElement.style.fontSize = this.size + 'px'
    }
  }
}
</script>

<style lang="scss">
</style>
